<template>
  <div v-if="selectedCategoryId != null">
    <alert :errors="errors" css_class="ma-1"></alert>
    <list-table
      class="mt-2"
      :itemList="itemList"
      :canAddInformation="canAddInformation"
      :isInfoPreview="false"
      :isCategory="false"
      :categoryId="selectedCategoryId"
      @on-delete-information="onDeleteInformation"
    ></list-table>
  </div>
  <div v-else>
    <alert :errors="errors" css_class="ma-1"></alert>
    <list-table
      class="mt-2"
      :itemList="itemNewList"
      :canAddInformation="canAddInformation"
      :isInfoPreview="true"
      :isCategory="false"
      :categoryId="0"
      @on-delete-information="onDeleteInformation"
    ></list-table>
    <div :class="{'category-tables': !isMobile}">
      <div v-for="(categoryData, index) in itemCategorizedList" :key="index" :class="{'category-table-container': !isMobile}">
        <list-table
          class="mt-2"
          :itemList="categoryData.informationList"
          :canAddInformation="canAddInformation"
          :isInfoPreview="true"
          :isCategory="true"
          :categoryId="categoryData.categoryId"
          @on-delete-information="onDeleteInformation"
        ></list-table>
      </div>
    </div>
  </div>
</template>

<script>
import ListTable from "../components/information-edits/list-table.vue";
import DateWrapper from "../logic/common/date-wrapper";
import Alert from "../components/common/alert.vue";
import AlertBuilder from "../logic/common/alert-contents";
import valueMapper from "@/logic/common/value-mapper";
import Api from "@/logic/api/api.js";
export default {
  components: {
    "list-table": ListTable,
    alert: Alert,
  },
  computed: {
    itemList() {
      if (this.selectedCategoryId === 0) {
        return this.$store.getters.manageInformationList;
      } else {
        const categories = this.$store.getters.manageCategoryList;
        const matchedCategory = categories.find(category => category.recordId === this.selectedCategoryId);
        return this.$store.getters.manageInformationList
          .filter(info => info.category === matchedCategory.category);
      }
    },
    itemNewList() {
      return this.$store.getters.manageInformationList.slice(0, 5);
    },
    itemCategorizedList() {
      const categories = this.$store.getters.manageCategoryList;
      const sortedCategoryList = categories.sort((a, b) => a.order - b.order);
      return sortedCategoryList.map(category => {
        return {
          categoryId: category.recordId,
          informationList: this.$store.getters.manageInformationList.filter(info => info.category === category.category).slice(0, 5)
        };
      });
    },
    isMobile() {
      // 現在の画面幅を取得
      const screenWidth = window.innerWidth; // ウィンドウの幅を取得
      console.log("screenWidth = " + screenWidth);
      // 幅が600以下のときはモバイルデバイスと判定
      return screenWidth <= 600; 
    },
  },
  data() {
    this.$nextTick(() => {
      this.reloadData();
    });
    return {
      errors: [],
      canAddInformation: false,
      selectedCategoryId: null,
    };
  },
  watch: {
    $route() {
      this.selectedCategoryId = this.$route.params.id ? parseInt(this.$route.params.id) : null;
      this.clearMessage();
      this.$nextTick(() => {
        this.reloadData();
      });
    },
  },
  mounted() {
    this.selectedCategoryId = this.$route.params.id ? parseInt(this.$route.params.id) : null;
  },
  methods: {
    /**
     * お知らせ一覧を取得する
     */
    reloadData() {
      this.$store.commit("setWaiting", true);

      const apiRequests = [];
      const processList = [];

      // 分類を取得する
      apiRequests.push("category.list");
      processList.push(
        Api.call("/admin/information/category", {})
      );

      // お知らせを取得する
      apiRequests.push("information");
      processList.push(
        Api.call("/admin/information", {})
      );

      Promise.all(processList)
        .then((result) => {
          //APIから取得した結果を画面に表示する
          let categoryList = [];
          if (apiRequests.includes("category.list")) {
            const idx = apiRequests.indexOf("category.list");
            const apiRes = result[idx] || {};
            const raw = Array.isArray(apiRes.categorys) ? apiRes.categorys : [];

            // is_restricted が true のものを除外
            categoryList = raw.filter(item => item?.is_restricted !== true);
            console.log("categoryList = " + JSON.stringify(categoryList));

          }
          let informationList = [];
          if (apiRequests.includes("information")) {
            this.canAddInformation = result[apiRequests.indexOf("information")].editable;
            console.log("canAddInformation = " + this.canAddInformation);
            informationList = result[apiRequests.indexOf("information")].informations;
            informationList.sort(function(a,b){
              if(a.record_date > b.record_date) return -1;
              if(a.record_date < b.recordD_date) return 1;
              return 0;
            });        
            console.log("informationList = " + JSON.stringify(informationList));
          }

          // しばらくお待ちくださいを閉じる
          this.$store.commit("setWaiting", false);

          // 新着のお知らせのフラグを落とす
          this.$store.commit("setInformationNotice", false);

          // 画面に反映する
          this.$store.commit(
            "setManageCategoryList",
            categoryList.map((category) => {
              return {
                recordId: category.record_id,
                category: category.category,
                order: category.order,
                usedNumber: category.used_number,
                categoryEdit: {
                  editable: true,
                },
              };
            })
          );
          this.$store.commit(
            "setManageInformationList",
            informationList.map((information) => {
              return {
                recordId: information.record_id,
                category: information.category,
                fileName: information.file_name,
                fileUrl: information.file_url,
                recordDate: new DateWrapper(
                  information.record_date
                ).format.build((d) => {
                  // 2000年よりも最近に更新があったのなら日時を返す
                  if (d.date.y >= 2000) {
                    return `${d.date.y}/${d.date.m02}/${d.date.d02}`;
                  }
                  // 2000年以前が最終更新日時であればハイフンを返す
                  return "-";
                }),
                informationEdit: {
                  editable: true,
                },
              };
            })
          );
        })
        .catch((result) => {
          this.$store.commit("setWaiting", false);
          Api.resolve(result);
        });
    },
    /**
     * エラーメッセージをクリアする
     */
    clearMessage() {
      this.errors = [];
    },
    /**
     * お知らせを削除する
     */
    onDeleteInformation(selected) {
      const deletedMap = {};
      console.log("selected[0] = ");
      console.log(selected[0]);
      console.log("selected[0].recordId = ");
      console.log(selected[0].recordId);
      // 送信パラメータを作成する
      const postData = {
        record_id: selected[0].recordId
      };
      console.log("postData = ");
      console.log(postData);
      this.clearMessage();
      this.$nextTick(() => {
        // お知らせを削除する
        this.$store.commit("setWaiting", true);
        Api.call("/admin/information/delete", postData)
          .then((result) => {
            this.$store.commit("setWaiting", false);
            const message = valueMapper
              .map({
                success: AlertBuilder.success("削除しました"),
                failed: AlertBuilder.error("削除に失敗しました"),
              })
              .get(result.message);
            if (message) {
              this.errors.push(message);
            }
            if (result.failed) {
              result.failed.forEach((info) => {
                this.errors.push(
                  AlertBuilder.error(
                    `[${deletedMap[info.uid]}]:${info.reason.jp}`
                  )
                );
              });
            }
            this.reloadData();
          })
          .catch((result) => {
            this.$store.commit("setWaiting", false);
            Api.resolve(result);
          });
      });
    },
  },
};
</script>

<style>
.category-tables {
  display: flex; /* フレックスボックスを使用して横並びに */
  flex-wrap: wrap; /* テーブルが折り返すように */
}

.category-table-container {
  flex: 1 1 50%; /* 各テーブルが50%幅を持つ */
  max-width: 50%; /* 幅の最大値を50%に設定 */
}
</style>

